import React from "react";

const LeftNavContainer = (props) =>
	<div className="sidebar-left">
		<ul className="nav nav-sidebar">{props.children}</ul>
	</div>;

export default LeftNavContainer;


/** WEBPACK FOOTER **
 ** ./src/scripts/components/leftnav/LeftNavContainer.jsx
 **/